import {FC, Fragment, useState} from 'react';
import {ImportDto} from '../../../../global/api';
import {ContractDataImportsTableMainRow} from './contract-data-imports-table-main-row';
import {ContractDataImportsTableCollapseRow} from './contract-data-imports-table-collapse-row';

interface Props {
  index: number;
  data: ImportDto;
}

export const ContractDataImportsTableRow: FC<Props> = ({index, data}) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => setExpanded(!expanded);

  return (
    <Fragment>
      <ContractDataImportsTableMainRow
        data={data}
        index={index}
        expanded={expanded}
        onToggleExpanded={toggleExpanded}
      />
      <ContractDataImportsTableCollapseRow data={data} expanded={expanded} />
    </Fragment>
  );
};
